import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./buttonViewStyles.css";
import { useFocusable } from "../../../utils/Helpers";
import { focusManager } from "../../../utils/Focus";
export var CloseButtonView = function (_a) {
    var onClose = _a.onClose;
    var t = useTranslation().t;
    var ref = useFocusable({
        group: "modalView",
        index: 0,
        onKeyDown: onClose,
        onKeyBack: onClose,
    });
    useEffect(function () {
        focusManager.manualFocus("modalView", 0);
    }, []);
    return (React.createElement("div", { className: "btn-container" },
        React.createElement("button", { id: "modal-close", tabIndex: 0, ref: ref, className: "purple-border-btn" }, t("modal.close"))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/buttons/CloseButtonView.tsx
// module id = 87
// module chunks = 1